// Анимация смс-сообщений
itsoftApp.createModule("messageAnimation", function() {

    var maxIndex = $(".message").length - 1,
        stepOut = -1,
        stepTop = 0,
        stepMiddle = 1,
        stepIn = 2,
        dataNum = 1,
        side = true;

    $(".message").each(function() {
        $(this).attr("data-num", dataNum)
        dataNum++;
        if (side) {
            $(this).addClass("message--right");
            side = false;
        }
        else {
            $(this).addClass("message--left");
            side = true;
        }

    });

    function changeMess() {

        if (stepOut >= maxIndex) {
            stepOut = 0;
        }
        if (stepTop >= maxIndex) {
            stepTop = 0;
        }
        if (stepMiddle >= maxIndex) {
            stepMiddle = 0;
        }
        if (stepIn >= maxIndex) {
            stepIn = 0;
        }

        stepOut++;
        stepTop++,
        stepMiddle++,
        stepIn++;

        /*console.log("stepOut", stepOut);
        console.log("stepTop", stepTop);
        console.log("stepMiddle", stepMiddle);
        console.log("stepIn", stepIn);*/

        $(".message").removeClass("message--out");
        $(".message").removeClass("message--top");
        $(".message").removeClass("message--middle");
        $(".message").removeClass("message--out");

        $(".message").each(function() {
            if ($(this).attr("data-num") == stepOut) {
                $(this).addClass("message--out")
            }
            if ($(this).attr("data-num") == stepTop) {
                $(this).addClass("message--top")
            }
            if ($(this).attr("data-num") == stepMiddle) {
                $(this).addClass("message--middle")
            }
            if ($(this).attr("data-num") >= stepIn) {
                $(this).addClass("message--in")
            }
            maxIndex = $(this).attr("data-num");
        });
    }
    setTimeout(function() {
        changeMess();
    }, 500);
    setInterval(function() {
        changeMess();
    }, 3000);

});
